import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
// import methodCommon from '@/utils/methodCommon'

const whiteList = ['/energy', '/memberCenter', '/energyMiniApp']

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (whiteList.indexOf(to.path) !== -1) {
    if (getToken()) {
      store.dispatch('GetInfo').then(() => { // 拉取用户信息
        next()
        NProgress.done()
      }).catch(() => {
        store.dispatch('FedLogOut').then(() => {
        })
      })
    } else {
      // 若未登入且在 用户中心 时，跳转回能量官网首页
      if (to.path === '/memberCenter') {
        next('/energy')
      }
      next()
      NProgress.done()
    }
  } else {
    next('/energy')
    NProgress.done()
  }
})

router.afterEach(() => {
  // Start check version
  let ElementVersionHash = document.getElementById("version-hash");
  if (ElementVersionHash) ElementVersionHash.parentNode.removeChild(ElementVersionHash);
  let HashVersionCheck = document.createElement("script");
  HashVersionCheck.setAttribute("src", './static/version.js?' + Date.now());
  HashVersionCheck.setAttribute("id", 'version-hash');
  document.body.appendChild(HashVersionCheck);
  // End check version

  NProgress.done()
})


// WEBPACK FOOTER //
// ./src/permission.js